import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const PolicyAckModal = ({ open, services, busy, onAgree, onClose }) => {
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    if (open) setAgreed(false);
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="policy-ack-modal" className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-2xl font-medium text-ink">
            <ShieldCheck className="h-6 w-6 text-bark" aria-hidden="true" />
            Before your first booking
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            Please read and agree to the policies for the service{services.length > 1 ? "s" : ""} in this booking. You only
            need to do this once per service.
          </DialogDescription>
        </DialogHeader>

        <div
          data-testid="policy-ack-list"
          data-lenis-prevent
          className="mt-2 max-h-[45vh] space-y-4 overflow-y-auto overscroll-contain pr-1"
        >
          {services.map((s) => (
            <div
              key={s.slug}
              data-testid={`policy-ack-item-${s.slug}`}
              className="rounded-2xl border border-ink/10 bg-cream/60 p-4"
            >
              <p className="font-display text-base font-medium text-ink">{s.name}</p>
              <p className="mt-2 text-xs leading-relaxed text-slate-600">{s.policy}</p>
            </div>
          ))}
        </div>

        <label
          data-testid="policy-ack-checkbox-label"
          className="mt-5 flex cursor-pointer items-start gap-3 rounded-2xl bg-cream-dark/60 p-4 text-sm text-navy"
        >
          <input
            type="checkbox"
            data-testid="policy-ack-checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            className="mt-0.5 h-4 w-4 shrink-0 accent-bark"
          />
          <span>I have read and agree to {services.length > 1 ? "these policies" : "this policy"}.</span>
        </label>

        <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            data-testid="policy-ack-back"
            onClick={onClose}
            className="rounded-full border border-ink/15 px-6 py-3 text-sm font-semibold text-navy transition-colors duration-200 hover:border-bark hover:text-bark"
          >
            Back to booking
          </button>
          <button
            type="button"
            data-testid="policy-ack-agree"
            onClick={onAgree}
            disabled={!agreed || busy}
            className="rounded-full bg-bark px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-bark-dark disabled:opacity-50"
          >
            {busy ? "Please wait…" : "Agree & continue"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
